import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "../../api/apiClient";
import { exportCaseEndpointApiV1CasesCaseIdExportPost } from "../../api/generated/sdk.gen";
import { CLIENT_KEYS } from "../../constants/clientKeys";

/**
 * Hook for exporting a case with specified file IDs
 */
export const useExportCase = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: { caseId: string; fileIds: string[] }) => {
      const { caseId, fileIds } = data;

      const response = await exportCaseEndpointApiV1CasesCaseIdExportPost({
        path: { case_id: caseId },
        body: { file_ids: fileIds },
        client: apiClient,
      });

      if ("error" in response && response.error) {
        throw new Error(
          `Failed to export case: ${JSON.stringify(response.error)}`
        );
      }

      return response.data;
    },
    onSuccess: () => {
      // Invalidate files query to refresh status if needed
      queryClient.invalidateQueries({
        queryKey: [CLIENT_KEYS.FILES],
      });
      // Also invalidate cases as the case status might change
      queryClient.invalidateQueries({
        queryKey: [CLIENT_KEYS.CASES],
      });
    },
    onError: error => {
      console.error("Error exporting case:", error);
    },
  });
};
